<mat-card>
  <mat-card-title>{{ viewMode ? 'User Details' : 'Edit User' }}</mat-card-title>
  <mat-card-content>
    <form *ngIf="!viewMode" [formGroup]="editForm" (ngSubmit)="saveChanges()" style="max-width: 100%; margin: 0 40px;">
      <!-- First Name and Last Name on the same row -->
      <div style="display: flex; gap: 16px;">
        <mat-form-field appearance="fill" style="flex: 1;">
          <mat-label>First Name</mat-label>
          <input matInput formControlName="firstName">
        </mat-form-field>

        <mat-form-field appearance="fill" style="flex: 1;">
          <mat-label>Last Name</mat-label>
          <input matInput formControlName="lastName">
        </mat-form-field>
      </div>

      <!-- Email -->
      <mat-form-field appearance="fill">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email">
      </mat-form-field>

      <!-- Password and Nickname on the same row -->
      <div style="display: flex; gap: 16px;">
        <mat-form-field appearance="fill" style="flex: 1;">
          <mat-label>Password</mat-label>
          <input matInput type="password" formControlName="password">
        </mat-form-field>

        <mat-form-field appearance="fill" style="flex: 1;">
          <mat-label>Nickname</mat-label>
          <input matInput formControlName="nickname">
        </mat-form-field>
      </div>

      <!-- Comments -->
      <mat-form-field appearance="fill">
        <mat-label>Comments</mat-label>
        <textarea matInput formControlName="comments" rows="5"></textarea>
      </mat-form-field>

      <!-- Active and Administrator on the same row -->
      <div style="display: flex; gap: 16px;">
        <mat-checkbox formControlName="isActive" style="flex: 1;">Active</mat-checkbox>
        <mat-checkbox formControlName="isAdministrator" style="flex: 1;">Administrator</mat-checkbox>
      </div>

      <div class="form-actions">
        <button mat-raised-button color="primary" type="submit">Save</button>
        <button mat-raised-button color="warn" type="button" (click)="closeDialog()">Cancel</button>
      </div>
    </form>

    <div *ngIf="viewMode">
      <p><strong>First Name:</strong> {{ data.user?.firstName }}</p>
      <p><strong>Last Name:</strong> {{ data.user?.lastName }}</p>
      <p><strong>Email:</strong> {{ data.user?.email }}</p>
      <p><strong>Nickname:</strong> {{ data.user?.nickname }}</p>
      <p><strong>Active:</strong> {{ data.user?.isActive ? 'Yes' : 'No' }}</p>
      <p><strong>Administrator:</strong> {{ data.user?.isAdministrator ? 'Yes' : 'No' }}</p>
      <p><strong>Comments:</strong> {{ data.user?.comments }}</p>
      <button mat-raised-button color="primary" (click)="closeDialog()">Close</button>
    </div>
  </mat-card-content>
</mat-card>
